var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.987305H513V342.991H0V0.987305Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 171.983H513V253.762H0V171.983Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 253.763H513V342.98H0V253.763Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.805 101.06L299.689 110.883L288.569 131.109L311.245 126.77L314.119 149.68L329.914 132.831L345.711 149.68L348.584 126.77L371.261 131.109L360.14 110.883L381.024 101.06L360.139 91.236L371.261 71.0116L348.584 75.3491L345.71 52.4404L329.914 69.2893L314.118 52.4404L311.245 75.3491L288.567 71.0116L299.688 91.2381L278.805 101.06Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.989258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRw);
export default __webpack_public_path__ + "static/media/RW.47135a53d46d3d5c417321544e6a7183.svg";
export { ForwardRef as ReactComponent };